import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import About from './components/SectionAbout';
import Carousel from './components/SectionCarousel';
import AppSection from './components/SectionApp';
import Topics from './components/SectionTopics';
import IndexSection from './components/SectionIndex';
import Comments from './components/SectionComments';
import Cards from './components/SectionCards';
import Contact from './components/SectionContact';
import Ranking from './components/SectionRanking';
import Updates from './components/SectionUpdates';
import Faq from './components/SectionFaq';
import Media from './components/SectionMedia';
import Features from './components/SectionFeatures';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Carousel />
        <AppSection />
        <Topics />
        <IndexSection />
        <Comments />
        <Cards />
        <Contact />
        <Ranking />
        <Updates />
        <Faq />
        <Media />
        <Features />
      </main>
      <Footer />
    </>
  );
}